import Vue from 'vue'
import Vuex from 'vuex'
import {Action, Mutation, VuexModule} from 'vuex-module-decorators'
import {alertModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import ApiException = MdbsCore.ApiException;

Vue.use(Vuex)

export default class BaseModule extends VuexModule {
    protected loading: boolean = false;
    static isStarting: boolean = true;

    @Mutation
    startLoading() {
        this.loading = true;
    }

    @Mutation
    stopLoading() {
        this.loading = false;
    }

    public static setStarting(starting: boolean) {
        BaseModule.isStarting = starting;
    }

    get isLoading(): boolean {
        return this.loading;
    }

    @Action({rawError: true})
    protected async execute (func: () => void) {
        this.context.commit("startLoading");
        try {
            await func();
        } catch (e) {
            await alertModule.handleException(e);
            this.context.commit("stopLoading");
            throw e;
        } finally {
            this.context.commit("stopLoading");
        }
    }

    @Action({rawError: true})
    protected async executeIgnoreNotFound (func: () => void) {
        this.context.commit("startLoading");
        try {
            await func();
        } catch (e) {
            if (ApiException.isApiException(e) && e.status == 404){
                this.context.commit("stopLoading");
                return
            }
            await alertModule.handleException(e);
            this.context.commit("stopLoading");
            throw e;
        } finally {
            this.context.commit("stopLoading");
        }
    }
}